import * as React from "react";
import { NoDataFound } from "..";

const Table = ({
  columns,
  data,
  NoFound,
  onRowClick = () => {},
  contentEditable,
  onInput,
  onKeyPress,
  firstColAsHeading = false,
}) => {
  const renderData = (c, row) => {
    return c.childKey
      ? c.toFixed
        ? row[c.key][c.childKey]?.toFixed(c.toFixed)
        : row[c.key][c.childKey]
      : c.type && c.type === "date"
      ? c.format(row[c.key])
      : c.toFixed
      ? row[c.key]?.toFixed(c.toFixed)
      : row[c.key];
  };

  const renderRow = (row, index) => {
    return (
      <tr key={index} style={{ cursor : "pointer" }} onClick={() => onRowClick(row)}>
        {columns.map((c, key) =>
          c.key === "action" ? (
            <td
              id="cell-value"
              key={`${key}-${index}`}
              onKeyPress={(e) => onKeyPress(e, key, index)}
            >
              {c.component(row)}
            </td>
          ) : (
            <td
              id="cell-value"
              key={`${key}-${index}`}
              contentEditable={
                key === 0
                  ? !firstColAsHeading && contentEditable
                  : contentEditable
              }
              onKeyPress={(e) => onKeyPress(e, key, index)}
            >
              {c.renderContent ? c.renderContent(row) : renderData(c, row)}
            </td>
          )
        )}
      </tr>
    );
  };

  return (
    <table className="table table-hover mb-0">
      <thead>
        <tr>
          {columns.map((c, key) => (
            <th key={key}>{c.name}</th>
          ))}
        </tr>
      </thead>
      {data?.length ? (
        <tbody>{data.map((row, index) => renderRow(row, index))}</tbody>
      ) : (
        <NoDataFound found={NoFound} />
      )}
    </table>
  );
};

export default Table;
